import { P } from 'components'
import { useEffect, useState } from 'react'
import { newFormatThousandSeparator } from 'utils/formatNumber'

const ComodityCardItem = ({
  comodity,
  amount,
  unit,
  price,
  total,
  useTalangin,
}) => {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768)
    }

    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <div
      className="d-flex flex-row gap-3 align-items-center justify-content-between mb-3"
      data-testid={`commodity-card-item-${comodity?.id ?? comodity?.label}`}
    >
      <div className="d-flex flex-row gap-2">
        <img
          src={comodity?.img ?? comodity?.linkFoto}
          className="rounded float-left"
          style={{
            width: isMobile ? '40px' : '50px',
            height: isMobile ? '40px' : '50px',
          }}
          alt="barang"
        />
        <div className="d-flex flex-column">
          {useTalangin && comodity?.agencyModel && (
            <P size="small" bold>
              <small
                style={{ backgroundColor: '#FEDF89' }}
                className="badge rounded-pill text-dark"
              >
                Dikenakan PPN
              </small>
            </P>
          )}
          <span style={{ fontSize: isMobile ? '12px' : '16px' }}>
            {comodity?.label}
          </span>
          <span
            className="text-primary"
            style={{
              fontWeight: 'normal',
              fontSize: isMobile ? '12px' : '16px',
            }}
          >
            {amount} {unit} x Rp
            {newFormatThousandSeparator(price, 0)}
          </span>
        </div>
      </div>
      <div
        className="text-primary fw-bold"
        style={{
          fontSize: isMobile ? '12px' : '16px',
        }}
      >
        Rp
        {newFormatThousandSeparator(total, 0)}
      </div>
    </div>
  )
}

export default ComodityCardItem
